module.exports = __webpack_public_path__ + "dist/media/ec_comp_social_share.a87be474.svg";